import { createAsyncThunk, createSlice, isAsyncThunkAction, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import fetchAPI from '../../../common/fetchAPI'
import { TimesheetPeriodTypeStateClass } from "./interfaces/TimesheetPeriodTypeStateClass";
import { sortData } from "../../../common/timeLiveFunction";
import moment from "moment";

const initialState: TimesheetPeriodTypeStateClass = {
    isLoading: false,
    TimesheetPeriodTypeList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'SystemTimesheetPeriodType',
    search: '',
    pageNo: 1,
    pageSize: 10
};

interface IThunkApi {
    state: {
        timesheetPeriodType: TimesheetPeriodTypeStateClass
    }
};

export const getAccountTimesheetPeriodTypeAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "TimesheetPeriodTypes/V2/getAccountTimesheetPeriodType",
        async (arg, thunkApi) => {

            //const response = await fetchAPI("api/TimeOffTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/V2/TimesheetPeriodTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }

    )
export const getAccountTimesheetPeriodTypeByAccountTimesheetPeriodTypeIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "TimesheetPeriodTypes/V2/getAccountTimesheetPeriodTypeByAccountTimesheetPeriodTypeId",
        async (arg, thunkApi) => {
            //const response = await fetchAPI('api/TimeOffTypes/' + arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/V2/TimesheetPeriodTypes/' + arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const updateTimesheetPeriodTypesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'TimesheetPeriodTypes/V2/updateTimesheetPeriodTypes',
        async (arg, thunkApi) => {
            if (arg.TimesheetPeriodEffectiveDate) {
                if (arg.TimesheetPeriodEffectiveDate instanceof Date) {
                    arg.TimesheetPeriodEffectiveDate = moment(arg.TimesheetPeriodEffectiveDate).format('YYYY-MM-DD')
                }
            }
            const { AccountTimesheetPeriodTypeId, IsTimeOffRequestRequired, selectedSystemTimesheetPeriodTypeValue, ...argWithoutId } = arg;
            //const response = await fetchAPI('api/TimeOffTypes/' + AccountTimeOffTypeId, 'POST', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/V2/TimesheetPeriodTypes/' + AccountTimesheetPeriodTypeId, 'PUT', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const timesheetPeriodTypeSlice = createSlice({
    name: "timesheetPeriodType",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.TimesheetPeriodTypeList;
            state.TimesheetPeriodTypeList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountTimesheetPeriodTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountTimesheetPeriodTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.TimesheetPeriodTypeList = payload.Data;
               // console.log('TimesheetPeriodTypeList:',state.TimesheetPeriodTypeList);
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountTimesheetPeriodTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })



            .addCase(getAccountTimesheetPeriodTypeByAccountTimesheetPeriodTypeIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountTimesheetPeriodTypeByAccountTimesheetPeriodTypeIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.selectedRecord = payload.Data[0];
                state.isLoading = false;
            })
            .addCase(getAccountTimesheetPeriodTypeByAccountTimesheetPeriodTypeIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            
            .addCase(updateTimesheetPeriodTypesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateTimesheetPeriodTypesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateTimesheetPeriodTypesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

    }
});

export const { resetSelectedRecordObjectInState,updateSorting, updatePagination } = timesheetPeriodTypeSlice.actions
export const timesheetPeriodTypeState = (state: RootState) => state.timesheetPeriodType
export default timesheetPeriodTypeSlice.reducer


